import { getDaysOfTheWeek } from '@utils/date/daysOfTheWeek';
import { SpaEntityWithTimeslots } from 'shared-types/Spa';

export async function getWeeklyTimeslots(
  getTimeslotsFunction: (arrivalDate: string) => Promise<SpaEntityWithTimeslots>,
  startDate: string,
  numberOfDays = 7
) {
  const days = getDaysOfTheWeek(startDate, numberOfDays);
  return (await Promise.all(days.map((day) => getTimeslotsFunction(day))))
    .map((day) => day.availability)
    .flat(1);
}
